import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {
  bodyText = '';
  role : string;
  companyId: string;
  userRoles = USER_ROLES;
  skipNavigation: boolean;
  refundAmount : string;
  constructor(private readonly router: Router, public readonly ref: DynamicDialogRef, public readonly config: DynamicDialogConfig,
    private readonly superAdminService: SuperAdminService, private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit(): void {
    this.bodyText = this.config.data.bodyText;
    this.skipNavigation = this.config?.data?.skipNavigation;
    this.refundAmount = this.config?.data?.refundAmount;
    this.role = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');
  }

  continue(): void {
    if (this.skipNavigation) {
      this.superAdminService.triggerPopupClose(true);
      this.ref.close();
      return;
    }
    this.ref.close();
    let navigationFromViewUrl = this.encryptStorage.getItem('navigationFromView');
    if (!navigationFromViewUrl) {
      const baseUrl = this.role === this.userRoles.SUPER_ADMIN ? `/super-admin/parking-list/${this.companyId}` : 'manager/parking';
      this.router.navigateByUrl(baseUrl);
    }else {
      this.router.navigateByUrl(navigationFromViewUrl);
    }
  }
}
